import { createFileRoute } from '@tanstack/react-router'
import EditionPrintRun from 'Edition/components/sections/General/EditionPrintRun'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/general-printrun')({
    component: EditionPrintRun,
})
